export default "__VITE_PUBLIC_ASSET__c39a6cfd__"